import * as React from 'react';
import {AnnualPolicyInfo, productHelper} from "@falcon/services";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import * as moment from "moment";
import NotificationModal from "../../../../../components/modals/NotificationModal";

interface IProps {
    allPoliciesAreCancelled: boolean,
    renewalPaymentFailed?: boolean,
    annualPolicyInfo?: AnnualPolicyInfo,
    paymentType?: string,
    interaction?: any,
    canChangePaymentDate?: boolean,
    paymentDay: string
    annualToMonthly?: boolean;
}

interface IState {
    showAlert: boolean
}


export class PaymentDaySection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showAlert: false,
        };
    }

    public render() {
        const {annualPolicyInfo, interaction} = this.props;
        let paymentDayToRender: string;
        let changeDateJourneyLink: string;
        let hasDebt: boolean = false;

        if (interaction) {
            if (!(productHelper.isHomeOrWolfMotor(interaction))) {
                paymentDayToRender = this.convertDate(this.props.paymentDay);
                changeDateJourneyLink = "/journey/show/product/FlowSubscription/process/mtaChangePaymentDay";
            } else if (this.props.annualToMonthly) {
                paymentDayToRender = this.convertWolfPaymentDate(this.props.paymentDay);
                changeDateJourneyLink = `/dashboard/account/changeRenewalPaymentDay/${interaction.agreementNumber}`;
            } else {
                paymentDayToRender = this.convertWolfPaymentDate(this.props.paymentDay);
                changeDateJourneyLink = `/dashboard/account/changePaymentDay/${interaction.agreementNumber}`;
                hasDebt = annualPolicyInfo?.hasDebt as boolean;
            }

            const disableButton = this.disableButton(hasDebt);

            return (
                <div className="text-center mt-4 payment-day-section payment-details-section grid-col-1-2">
                    {this.props.annualToMonthly &&
                        <div className="bubble-container">
                            <div className="corner-bubble">Renewal only</div>
                        </div>
                    }
                    <img alt="Cash icon"
                         src={this.props.paymentType === "annual-product-monthly-payments" ? "/img/payment-card-icon.png" : "/img/Flow-payment-details.svg"}
                         className="payment-day-section__img-icon pt-2 product-section-img icon-calendar-white-replace"/>
                    <div className="dashboard-panel-title my-3">Payment day</div>
                    <div className="grid-col-2">
                        Every
                        <span className="font-weight-semi-bold"> {paymentDayToRender!} </span>
                        of the month
                    </div>
                    <div className="px-3 my-4 grid-col-2">
                        <button
                              id="addNewCard"
                              disabled={disableButton}
                              className={disableButton ?
                                  "btn-small btn-primary btn-disabled-dashboard m-auto" : `btn-small btn-white-dashboard m-auto`}
                              onClick={e =>
                                  this.handleClick(e, disableButton, changeDateJourneyLink)}>
                            Change day
                        </button>
                    </div>
                    <NotificationModal show={this.state.showAlert} hide={this.hideAlert}>
                        {!this.props.canChangePaymentDate ? "This action is not allowed"
                            : (this.props.allPoliciesAreCancelled ?
                            "Due to policy cancellation this action is not allowed" :
                            "Due to missed payment this action is not allowed")}
                    </NotificationModal>
                </div>
            )
        } else {
            return <React.Fragment/>
        }
    }

    private convertDate = (date: string): string => {
        return PluginTemplates.getOrdinal(parseInt(moment(date).format("DD"), 10))
    }

    private convertWolfPaymentDate = (day: string): string => {
       return PluginTemplates.convertWolfPaymentDate(day);
    }

    private disableButton(hasDebt: boolean) {
        return this.props.allPoliciesAreCancelled || this.props.renewalPaymentFailed || hasDebt || !this.props.canChangePaymentDate;
    }

    private handleClick = (event: any, renewalFailed: boolean, changeDateJourneyLink: string): void => {
        event.preventDefault();
        if (renewalFailed) {
            this.setState({showAlert: true});
        } else {
            window.location.assign(changeDateJourneyLink);
        }
    };

    private hideAlert = (): void => {
        this.setState({showAlert: false});
    }
}
